import React from 'react'
import PropTypes from 'prop-types'

import { Checkbox as AntdCheckbox } from 'antd'

const Checkbox = ({
  checked,
  disabled,
  indeterminate,
  onChange,
  children,
  className,
}) => {
  return (
    <AntdCheckbox
      className={className}
      checked={checked}
      disabled={disabled}
      indeterminate={indeterminate}
      onChange={onChange}
    >
      {children}
    </AntdCheckbox>
  )
}

Checkbox.defaultProps = {
  disabled: false,
  indeterminate: false,
  onChange: () => {},
}

Checkbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node,
}

export default Checkbox
